import { customElement, property } from 'lit/decorators.js';
import { html, LitElement } from "lit";
import { tagStyle } from "./tag.styles"

// eslint-disable-next-line
declare let _paq: any

@customElement('sbk-tag')
export class SbkTag extends LitElement {

    @property()
    href = '';

    @property({ attribute: 'title' })
    tagTitle = '';

    @property()
    area = '';

    @property()
    variant: 'muted' | '' = '';

    @property({ type: Boolean })
    hasCloseButton = false;

    static get styles() {
        return tagStyle;
    }

    async firstUpdated() {
        this._initializeTracking();
    }

    render() {
        return html`
            <div class="tag__wrapper">
                <a data-analytics-area=${this.area} data-analytics-title=${this.tagTitle} href=${this.href}
                   class=${this.variant}>
                    <slot></slot>
                    ${this.hasCloseButton ? html`
                        <sbk-round-button
                            icon="close"
                            size="extra-small"
                            variant="icon-only"
                            @click=${this._onClose}
                            aria-label="Tag entfernen">
                        </sbk-round-button>
                    ` : ''}
                </a>
            </div>
        `;
    }

    _initializeTracking() {
        const url = window.location.href;
        const title = this.tagTitle;
        const area = this.area;
        window.setTimeout(function () {
            _paq.push(['trackEvent', area, title, url])
        }, 1000);
    }

    private _onClose(event: Event) {
        event.stopPropagation();
        this.dispatchEvent(new CustomEvent('remove-tag', {
            detail: { title: this.tagTitle },
            bubbles: true,
            composed: true
        }));
    }
}
